module.exports = __webpack_public_path__ + "img/img-standard-4-txt.bbda51d4.jpg";